import { useMemo } from 'react';
import { useAsync } from 'react-use';

import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

/**
 * Loads the supervisory-org groups an owner picker offers and finds the one
 * `owner` refers to.
 */
export const useSupervisoryOrgOwner = (owner: string) => {
  const catalogApi = useApi(catalogApiRef);

  const { value: ownerEntities, loading } = useAsync(() =>
    catalogApi.getEntities({
      filter: { kind: 'Group', 'spec.type': 'supervisory-org' },
    }),
  );
  const ownerOptions: Entity[] = useMemo(
    () => ownerEntities?.items || [],
    [ownerEntities],
  );
  const selectedOwner = useMemo(
    () => ownerOptions.find(e => stringifyEntityRef(e) === owner) || null,
    [ownerOptions, owner],
  );

  return { ownerOptions, selectedOwner, loading };
};
